import { render, staticRenderFns } from "./moreList.vue?vue&type=template&id=86014362&"
import script from "./moreList.vue?vue&type=script&lang=ts&"
export * from "./moreList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports